<template >
  <v-app class="px-7">
    <v-app-bar app color="#f7f7f7" light hide-on-scroll elevation="0">
      <v-btn
          v-if="responsive"
          class="default v-btn--simple"
          dark
          color="#10938F"
          icon
          @click.stop="onClickBtn"
      >
        <v-icon color="#10938F">mdi-view-list</v-icon>
      </v-btn>
      <v-toolbar-title class="gray--text">{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-select
          v-if="showBranchSelector && canSeeAllBranches && branches.length > 0"
          v-model="selectedBranchId"
          :items="branchItems"
          item-text="name"
          item-value="id"
          label="Branch"
          dense
          outlined
          hide-details
          style="max-width: 200px; margin-right: 12px;"
          @change="onBranchChange"
      ></v-select>
      <v-chip
          v-if="showBranchSelector && !canSeeAllBranches && userBranch"
          small
          color="#14AAA6"
          text-color="white"
          class="mr-2"
      >
        {{ userBranch.name }}
      </v-chip>
      <slot class="px-0"></slot>
    </v-app-bar>

    <v-breadcrumbs
        v-show="ShowBreadcrumbs"
        :items="breadcrumbs"
        divider=">"
        class="breadcrumb mb-9"
    >
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item :to="item.to" :exact="item.exact">
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: ["title"],
  data() {
    return {
      ShowBreadcrumbs: false,
    };
  },
  computed: {
    ...mapGetters(["getSelectedBranchId", "getBranches"]),
    responsive() {
      if (
          this.$vuetify.breakpoint.name == "xs" ||
          this.$vuetify.breakpoint.name == "sm" ||
          window.innerWidth <= 1069
      ) {
        return true;
      } else {
        return false;
      }
    },
    showBranchSelector() {
      return this.$route.path === '/appointements' || this.$route.path === '/';
    },
    currentUser() {
      return JSON.parse(localStorage.getItem('user') || 'null');
    },
    canSeeAllBranches() {
      const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
      return permissions.includes('ADMINISTRATOR') || permissions.includes('show_all_branches');
    },
    userBranch() {
      return this.currentUser?.branch || null;
    },
    branches() {
      return this.getBranches || [];
    },
    branchItems() {
      return [{ id: null, name: 'All Branches' }, ...this.branches];
    },
    selectedBranchId: {
      get() {
        return this.getSelectedBranchId;
      },
      set(val) {
        this.setSelectedBranchIdAction(val);
      }
    },
    breadcrumbs() {
      let pathArray = this.$route.path.split("/");
      pathArray.shift();

      let breadcrumbArray = [];
      let fullPath = "";

      if (pathArray.length > 1) {
        this.ShowBreadcrumbs = true;
        pathArray.forEach((path, index) => {
          fullPath += `/${path}`;
          let route = this.$router.match(fullPath);
          if (route.meta && route.meta.breadcrumb) {
            breadcrumbArray.push({
              text: route.meta.breadcrumb,
              to: fullPath,
              exact: true,
            });
          }
        });

        breadcrumbArray[breadcrumbArray.length - 1].text = this.title;
      }
      return breadcrumbArray;
    }
  },
  methods: {
    ...mapActions(["setSelectedBranchIdAction", "fetchBranches"]),
    onClickBtn() {
      this.$store.dispatch('toggleDrawerAction');
    },
    onBranchChange(branchId) {
      this.$emit('branch-changed', branchId);
    },
  },
  watch: {
    showBranchSelector: {
      immediate: true,
      handler(val) {
        if (val && this.canSeeAllBranches && this.branches.length === 0) {
          this.fetchBranches();
        }
      }
    }
  }
};
</script>

<style scoped>
.breadcrumb {
  margin: -36px -36px 15px -36px;
  background-color: aliceblue;
  padding: 10px 12px;
}

.v-app-bar{
  border-color: lightgray !important;
  border-bottom: 1px solid;
}
</style>
